import * as React from "react";
import { InputBase, InputBaseInput } from "@/components/ui/input-base";
import { cn } from "@/lib/utils";

interface UnitInputProps extends React.ComponentProps<typeof InputBaseInput> {
  unit: "%" | "kcal/g" | "g" | "mg" | "°C" | "kcal";
  containerClassName?: string;
  inputClassName?: string;
  variant?: "default" | "critical";
}

const UNIT_CONFIG = {
  "%": {
    type: "number",
    step: "any",
  },
  "kcal/g": {
    type: "number",
    step: "any",
    min: 0,
  },
  g: {
    type: "number",
    step: "any",
    min: 0,
  },
  mg: {
    type: "number",
    step: "any",
    min: 0,
  },
  "°C": {
    type: "number",
    step: "any",
  },
  kcal: {
    type: "number",
    step: "any",
    min: 0,
  },
};

export const UnitInput = React.forwardRef<HTMLInputElement, UnitInputProps>(
  ({ unit, inputClassName, className, variant = "default", ...props }, ref) => {
    return (
      <InputBase
        className={cn(
          "focus-within:ring-ring items-stretch gap-1 py-0 focus-within:border-transparent focus-within:ring-2",
          className,
          variant === "critical" && "interactive-critical",
        )}
      >
        <InputBaseInput
          ref={ref}
          className={cn(inputClassName)}
          autoComplete="off"
          {...UNIT_CONFIG[unit]}
          {...props}
        />
        <div className="text-muted-foreground flex items-center text-sm">
          <div>{unit}</div>
        </div>
      </InputBase>
    );
  },
);

UnitInput.displayName = "UnitInput";
